<template>
  <li class="add-module-draggable">
    <button
      :aria-describedby="`add-module-draggable__aria-description--${uniqueId}`"
      class="add-module-draggable__button"
      @click="$emit('addModule')"
    >
      {{ moduleDisplayName }}
      <span
        :id="`add-module-draggable__aria-description--${uniqueId}`"
        class="add-module-draggable__aria-description"
      >
        {{ $t('Press Enter to add a module') }}
      </span>
    </button>
  </li>
</template>

<script>
import { get, uniqueId } from 'lodash-es';

export default {
  name: 'AddModuleDraggable',
  props: {
    options: {
      type: Object, // most of these options are used when dragging rather than in this component
      required: true,
    },
  },
  emits: ['addModule'],
  data() {
    return {
      uniqueId: uniqueId(),
    };
  },
  computed: {
    moduleDisplayName() {
      const isWordTracking = get(this, 'options.options.word_tracking.enabled', false);
      if (isWordTracking) {
        return this.$t('Word Tracking');
      }
      if (this.options?.type === 'advanced_button') {
        return this.$t('Button');
      }
      return this.options?.name;
    },
  },
};
</script>

<style lang="stylus">
.add-module-draggable {
  &__button {
    background: transparent;
    border: 0;
    padding: $nebula-space-1x $nebula-space-2x;
    text-align: left;
    width: 100%;
  }

  &__aria-description {
    display: none;
  }
}
</style>
